// src/services/http/tokenService.ts
import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';
import axios from 'axios'; // 🔥 讓 Web/App 都統一使用純淨的原生 axios

export async function tokenService(baseURL: string) {
  try {
    if (Capacitor.isNativePlatform()) {
      // 📱 APP mode: Use OAuth2 token endpoint with refresh_token
      const { value: refreshToken } = await Preferences.get({ key: 'refresh_token' });
      
      if (!refreshToken) {
        throw new Error('No refresh token found');
      }

      const response = await axios.post(
        `${baseURL}/api/server/oauth2/token`,
        new URLSearchParams({
          grant_type: 'refresh_token',
          refresh_token: refreshToken,
          client_id: 'app-client'
        }),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      );

      const tokens = response.data;

      return tokens;
    } else {
      // 🌐 Web mode: 改用乾淨的 axios 實例直接打絕對路徑，並手動帶上 withCredentials
      // 這樣可以 100% 避開攔截器內部 api() 的循環引用死鎖問題，確保刷新請求的純粹性
      const res = await axios.post(
        `${baseURL}/api/client/refresh`,
        {},
        {
          withCredentials: true // ⭐ 確保 BFF 模式帶上 Session Cookie
        }
      );
      return res.data;
    }
  } catch (err) {
    throw err;
  }
}